export const TypeEnum = {
  WithBenefit: 'true,false,false',
  AlreadyUsedBenefit: 'false,true,false',
  OutOfStockBenefit: 'false,false,true',
};

export const PopUpTypeEnum = {
  Unknown: 'Unknown',
  WithBenefit: 'WithBenefit',
  AlreadyUsedBenefit: 'AlreadyUsedBenefit',
  OutOfStockBenefit: 'OutOfStockBenefit',
  WithOutBenefit: 'WithOutBenefit',
};

export const ProgressTypeEnum = {
  SMS: 'SMS',
  Browser: 'Browser',
};
